var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _rect2, _rect3, _path18, _path19, _path20, _path21, _rect4, _rect5, _rect6, _path22, _path23, _path24, _path25, _rect7, _rect8, _rect9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle3, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "study",
    xmlns: "http://www.w3.org/2000/svg",
    width: 398,
    height: 296.455,
    viewBox: "0 0 398 296.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 31.128,
    cy: 31.128,
    r: 31.128,
    transform: "translate(104.343 145.995)",
    fill: "#e5e5e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M413.552,466.684a31.131,31.131,0,0,0,51.869,32.945,31.131,31.131,0,1,1-51.869-32.945Z",
    transform: "translate(-301.065 -310.352)",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M277.338,364.626h.085l1.539,88.254h-3.25Z",
    transform: "translate(-141.781 -187.503)",
    fill: "#cbcbcb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 37.494,
    cy: 37.494,
    r: 37.494,
    transform: "translate(152.212 89.328)",
    fill: "#e5e5e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M571.718,354.38a37.5,37.5,0,0,1-62.475,39.682,37.5,37.5,0,1,0,62.475-39.682Z",
    transform: "translate(-354.329 -252.601)",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M388.244,261.075h-.1l-1.854,106.3H390.2Z",
    transform: "translate(-198.642 -134.253)",
    fill: "#cbcbcb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M429.528,329.263l5.091-4.072c-3.955-.436-5.58,1.721-6.245,3.428-3.09-1.283-6.453.4-6.453.4l10.186,3.7A7.707,7.707,0,0,0,429.528,329.263Z",
    transform: "translate(-309.425 -237.562)",
    fill: "#cbcbcb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M403.111,256.936l5.091-4.072c-3.955-.436-5.58,1.721-6.245,3.428-3.09-1.283-6.453.4-6.453.4l10.186,3.7A7.708,7.708,0,0,0,403.111,256.936Z",
    transform: "translate(-295.841 -200.369)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M551.569,303.7l5.091-4.072c-3.955-.436-5.58,1.721-6.245,3.428-3.09-1.283-6.453.4-6.453.4l10.186,3.7A7.708,7.708,0,0,0,551.569,303.7Z",
    transform: "translate(-372.183 -224.416)",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M549.266,620.569s.195-4.082,4.188-3.607",
    transform: "translate(-374.91 -387.61)",
    fill: "#cbcbcb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M605.107,620.569s.195-4.082,4.188-3.607",
    transform: "translate(-403.625 -387.61)",
    fill: "#cbcbcb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M588.848,620.569s.195-4.082,4.188-3.607",
    transform: "translate(-395.265 -387.61)",
    fill: "#cbcbcb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M529.876,620.569s-.195-4.082-4.188-3.607",
    transform: "translate(-362.785 -387.61)",
    fill: "#cbcbcb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M564.716,621.15s-.195-4.081-4.188-3.607",
    transform: "translate(-380.701 -387.909)",
    fill: "#cbcbcb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M441.266,686.569s.195-4.081,4.188-3.607",
    transform: "translate(-319.373 -421.549)",
    fill: "#cbcbcb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M497.107,686.569s.195-4.081,4.188-3.607",
    transform: "translate(-348.088 -421.549)",
    fill: "#cbcbcb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M480.848,686.569s.195-4.081,4.188-3.607",
    transform: "translate(-339.727 -421.549)",
    fill: "#cbcbcb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M421.876,686.569s-.195-4.081-4.188-3.607",
    transform: "translate(-307.248 -421.549)",
    fill: "#cbcbcb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M456.716,687.15s-.195-4.082-4.188-3.607",
    transform: "translate(-325.164 -421.848)",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 52.199,
    height: 4.651,
    transform: "translate(275.518 73.693)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 52.199,
    height: 4.651,
    transform: "translate(275.518 90.828)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 52.199,
    height: 4.651,
    transform: "translate(275.518 106.178)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M717.1,294.927A6.069,6.069,0,1,1,723.168,301h0A6.076,6.076,0,0,1,717.1,294.927Z",
    transform: "translate(-461.216 -218.908)",
    fill: "#16c389"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M717.1,330.2a6.069,6.069,0,1,1,6.068,6.069h0A6.075,6.075,0,0,1,717.1,330.2Z",
    transform: "translate(-461.216 -237.047)",
    fill: "#16c389"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M717.1,361.8a6.069,6.069,0,1,1,6.069,6.069h0A6.075,6.075,0,0,1,717.1,361.8Z",
    transform: "translate(-461.216 -253.296)",
    fill: "#16c389"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M420.647,213.179l-.767-.6,19.649-25.3h25.7v.972H440Z",
    transform: "translate(-215.916 -96.308)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 52.199,
    height: 4.651,
    transform: "translate(0 129.071)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 52.199,
    height: 4.651,
    transform: "translate(0 146.206)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 52.199,
    height: 4.651,
    transform: "translate(0 161.555)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M319.294,415h0a6.069,6.069,0,1,1,6.069-6.069A6.069,6.069,0,0,1,319.294,415Z",
    transform: "translate(-253.53 -277.53)",
    fill: "#16c389"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M319.294,450.27h0a6.069,6.069,0,1,1,6.069-6.069A6.069,6.069,0,0,1,319.294,450.27Z",
    transform: "translate(-253.53 -295.67)",
    fill: "#16c389"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M319.294,481.869h0a6.069,6.069,0,1,1,6.069-6.069A6.069,6.069,0,0,1,319.294,481.869Z",
    transform: "translate(-253.53 -311.919)",
    fill: "#16c389"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M205.987,327.179,186.63,302.256H161.408v-.972h25.7l.146.188,19.5,25.112Z",
    transform: "translate(-83.001 -154.93)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 52.199,
    height: 4.651,
    transform: "translate(181.279 3.743)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 52.199,
    height: 4.651,
    transform: "translate(181.279 20.878)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 52.199,
    height: 4.651,
    transform: "translate(181.279 36.228)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M523.1,150.927A6.069,6.069,0,1,1,529.169,157h0a6.075,6.075,0,0,1-6.068-6.069Z",
    transform: "translate(-361.455 -144.858)",
    fill: "#16c389"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M523.1,186.2a6.069,6.069,0,1,1,6.069,6.069h0A6.075,6.075,0,0,1,523.1,186.2Z",
    transform: "translate(-361.455 -162.997)",
    fill: "#16c389"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M523.1,217.8a6.069,6.069,0,1,1,6.069,6.069h0A6.075,6.075,0,0,1,523.1,217.8Z",
    transform: "translate(-361.455 -179.246)",
    fill: "#16c389"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M226.647,69.179l-.767-.6,19.649-25.3h25.7v.972H246Z",
    transform: "translate(-116.155 -22.258)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M752.312,589.931h-3.278l-1.56-12.647h4.839Z",
    transform: "translate(-384.376 -296.859)",
    fill: "#ffb7b7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M938.3,750.222H927.729v-.134a4.115,4.115,0,0,1,4.115-4.115H938.3Z",
    transform: "translate(-569.528 -453.971)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M723.312,589.931h-3.278l-1.56-12.647h4.839Z",
    transform: "translate(-369.463 -296.859)",
    fill: "#ffb7b7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M909.3,750.222H898.729v-.134a4.115,4.115,0,0,1,4.115-4.115H909.3Z",
    transform: "translate(-554.616 -453.971)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M708.366,430.594l-4.443,7.065,7.458,71.29,7.794.472,1.639-61.572,2.733,32.912-1.08,28.66,8.024.389,4.768-41.582,3.59-32.887-7.044-6.558Z",
    transform: "translate(-361.981 -220.495)",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M921.387,466.142l-12.144.486L897.99,522.143s18.291,9.077,25.7.826l4.454-3.263Z",
    transform: "translate(-554.236 -310.073)",
    fill: "#16c389"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M943.661,466.142l10.687,6.228L950.4,498.445l3.462,26.587L942.618,523.2s-2.3-24.754-.808-32.527S943.661,466.142,943.661,466.142Z",
    transform: "translate(-576.51 -310.073)",
    fill: "#3f3d56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M901.663,467.142l-12.787,6.563.974,28.878-6.6,21.879s13.16,4.211,15.422-2.387S901.663,467.142,901.663,467.142Z",
    transform: "translate(-546.656 -310.587)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M951.719,585.625a3.245,3.245,0,0,0,1.2-4.83l3.859-6.333-3.276-3.284-5.325,9.02a3.263,3.263,0,0,0,3.542,5.427Z",
    transform: "translate(-579.441 -364.086)",
    fill: "#ffb7b7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M953.823,482l5.095-4.038s4.818,3.943,4.7,7.723S964.94,509.6,964.94,509.6L956.99,533.53l-5.921-4.737L958,510.11l-5.466-15.942Z",
    transform: "translate(-581.53 -316.152)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M885.293,587.832a3.245,3.245,0,0,1-.508-4.95l-2.929-6.813,3.706-2.79,4,9.68a3.263,3.263,0,0,1-4.271,4.874Z",
    transform: "translate(-545.939 -365.166)",
    fill: "#ffb7b7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M889.276,484.744l-4.476-4.715s-5.325,3.225-5.74,6.984-4.678,23.488-4.678,23.488l4.5,24.812,6.529-3.856-4.236-19.473,7.656-15.013Z",
    transform: "translate(-542.096 -317.214)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 8.295,
    cy: 8.295,
    r: 8.295,
    transform: "translate(353.172 135.851)",
    fill: "#ffb7b7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M923.26,421.427a4.325,4.325,0,0,0-2.443.581,3.6,3.6,0,0,1-2.457.428,2.518,2.518,0,0,1-1.543-1.712,7.439,7.439,0,0,1-.209-2.378l.883.51-.6-1.014,8.608-.951c2.6-.288,5.524-.488,7.55,1.173a7.528,7.528,0,0,1,2.171,3.483c1.718,5.26,3.669,12.925-5.15,14.489-1.229-.34.776-4.865.755-6.14s-.722-2.709-1.983-2.9l-.923,1.283c.591-.821-1.506-3.489-2.027-4.009a8.3,8.3,0,0,1-1.262-1.338C924.211,422.289,924.206,421.594,923.26,421.427Z",
    transform: "translate(-563.799 -284.646)",
    fill: "#2f2e41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M916.1,754.114H829.146a.486.486,0,1,1,0-.972H916.1a.486.486,0,1,1,0,.972Z",
    transform: "translate(-518.584 -457.658)",
    fill: "#cbcbcb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.41974d534aed40fa36bb80905f237336.svg";
export { ForwardRef as ReactComponent };